const toIndex = (str, fallback = 0) => {
  const n = parseInt(str)
  return Number.isNaN(n) || n < 0 ? fallback : n
}

export default toIndex
